(function(){
  'use strict';
  function syncTaskState(){
    var editor=document.querySelector('[data-jp-studio-editor]:not([hidden])');
    var journey=document.querySelector('[data-jp-p0-journey]:not([hidden])');
    document.body.classList.toggle('jp-task-active',Boolean(editor||journey));
  }
  function init(){
    syncTaskState();
    var observer=new MutationObserver(syncTaskState);
    document.querySelectorAll('[data-jp-studio-editor],[data-jp-p0-journey]').forEach(function(node){observer.observe(node,{attributes:true,attributeFilter:['hidden','data-jp-p0-state']});});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
